
<template>
  <div class="wrap-black text-center">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <p class="xs-pb-20">
            Forgot Your Password?<br />
            Please Enter Your Email Address Below.
          </p>

          <form method="post" v-on:submit.prevent="submit" class="form-pub">
            <div v-if="currentUser.errors">
              <div v-for="msg in currentUser.errors" role="alert" class="alert alert-contrast alert-danger alert-dismissible">
                <div class="message">{{msg}}</div>
              </div>
            </div>

            <div class="form-group">
              <input v-model="credentials.email" name="email" class="form-control" type="email" autofocus placeholder="Your E-mail" autocomplete="off" required="required">
            </div>

            <p class="xs-pt-20">We will send you an email with a password reset link.</p>

            <div class="alert alert-success" v-if="showSuccess">We've sent you an email with a password reset link. Please check your emails for instructions.</div>

            <div class="form-group xs-pt-10">
              <button class="btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width" :disabled="!credentials.email || saving">{{saving ? 'Please wait...' : 'Submit'}}</button>
            </div>
            <p class="xs-pt-30 footer-link">Don't have a account? <router-link to="/signup"><strong>Sign up now</strong></router-link>.</p>
            <p class="footer-link">Forgot your password? <router-link to="/forgot-password"><strong>Reset password</strong></router-link>.</p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapState } from 'vuex'

export default {

  created() {
    this.$store.commit(`CLEAR_USER_ERRORS`);
  },

  methods: {
    submit() {
      this.$store.commit(`CLEAR_USER_ERRORS`);
      this.showSuccess = false;
      this.saving = true;

      var self = this;

      let payload = {
        credentials: {
          email: this.credentials.email,
          redirect_url: 'http://www.clex.ca/reset-password', //'http://localhost:8080/reset-password'
        },
        callback: function (errors) {
          self.saving = false;
          if (!errors) {
            self.showSuccess = true;
            self.credentials.email = '';
          }
        }
      }

      this.$store.dispatch('forgotPassword', payload);
    },
  },

  computed: {
    ...mapState([
      'currentUser'
    ])
  },

  data() {
    return {
      credentials: {
        email: null,
      },
      showSuccess: false,
      saving: false,
    }
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  p {font-size:18px;line-height:24px;}
  form {max-width:460px;margin:0px auto;}
  .footer-link a {color:#FFFFFF;}

  @media (max-width: 767px) {
    .wrap-black { padding: 40px 20px; }
  }
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?28eeef62